module.exports = __webpack_public_path__ + "img/icon_Site_B.bca09bf2.svg";